module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/error-cover-b69cd9da90c8f2ef537cfdcb54ebf483.jpg";